import moment from "moment";
import { FIELD_ICON } from "../styles/media";
import { FIELDS, CITIES, PAYMENT_METHOD, SERVICES, REVIEWS_TAGS } from "../utils/constants";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../shared/NormalButton";
import WorkerModalContainer from "../../containers/shared/WorkerModalContainer";
import SelectField from "../shared/SelectField";
import MultiSelect from "../shared/MultiSelect";
import GetRequestStyle from "../helpers/GetRequestStyle";
import { UserContext } from "../../App";
import RatingStars from "../shared/RatingStars";
import { useTranslation } from "react-i18next";

const ReviewCard = ({review,newRequest=false,workersOptions=[],handleAddWorkerAction,forceCloseModal=false}) => {
    const {t, i18n} = useTranslation();

    const [addWorkerToRequset, setAddWorkerToRequset] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [selectedWorker, setSelectedWorker] = useState(null);

    const {fields} = useContext(UserContext);

    useEffect(()=>{
        if(moment) {
            moment?.locale('en-US');
        }
    },[])

    const getServiceName = (list,code) => {
        return SERVICES?.find(s=>s?.field?.code === review?.field)?.maintenanceListPerDevice?.find(m=>m?.device?.code === list)?.maintenanceList?.find(l=>l?.code === code)?.name || '-';
    }

    const handleCloseModal = () => {
        setAddWorkerToRequset(false);
    }

    const handleClickAddWorker = () => {
        setSelectedWorker(null);
        setAddWorkerToRequset(true);
    }

    useEffect(()=>{
        if(selectedWorker) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[selectedWorker])

    useEffect(()=>{
        if(forceCloseModal) {
            setAddWorkerToRequset(false);
        }
    },[forceCloseModal])


    return (
        <>
        <div className="w-full lg:w-[calc(33.3333%-12px)] bg-white rounded-[12px] p-[12px] relative pb-[60px]">
            <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                <div className="w-[50%]">
                        <RatingStars rating={review?.rateSum} />
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {t('reviews.requestNumber')} {review?.requestPrettyId}
                </div>
            </div>
            <div className="flex flex-nowrap justify-between items-center py-[12px]">
                <div className="w-[50%]">
                    <div className="inline-block me-[4px]">
                        {FIELD_ICON(review?.field,16,16,'fill-blue')}
                    </div>
                    <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                        {fields?.find(f=>f?.field?.code === review?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === review?.field)?.field?.name?.ar}
                    </div>
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {t('reviews.date')} {moment(review?.review?.createdAt).format('DD/MM/YYYY HH:mmA')}
                </div>
            </div>
            <div className="pt-[12px]">
                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('reviews.workerName')}
                    </span>
                    {review?.name} - <span dir="ltr">{`[ ${review?.username} ]`}</span>
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[3px]">
                            <path d="M6 6.375C4.415 6.375 3.125 5.085 3.125 3.5C3.125 1.915 4.415 0.625 6 0.625C7.585 0.625 8.875 1.915 8.875 3.5C8.875 5.085 7.585 6.375 6 6.375ZM6 1.375C4.83 1.375 3.875 2.33 3.875 3.5C3.875 4.67 4.83 5.625 6 5.625C7.17 5.625 8.125 4.67 8.125 3.5C8.125 2.33 7.17 1.375 6 1.375Z" fill="#344854"/>
                            <path d="M10.2951 11.375C10.0901 11.375 9.92007 11.205 9.92007 11C9.92007 9.275 8.16008 7.875 6.00008 7.875C3.84008 7.875 2.08008 9.275 2.08008 11C2.08008 11.205 1.91008 11.375 1.70508 11.375C1.50008 11.375 1.33008 11.205 1.33008 11C1.33008 8.865 3.42508 7.125 6.00008 7.125C8.57508 7.125 10.6701 8.865 10.6701 11C10.6701 11.205 10.5001 11.375 10.2951 11.375Z" fill="#344854"/>
                        </svg>
                        {t('reviews.customerName')}
                    </span>
                    {review?.review?.reviewer}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[3px]">
                            <path d="M8 11.375H1.5C1.02 11.375 0.625 10.98 0.625 10.5V4C0.625 1.79 1.79 0.625 4 0.625H8C10.21 0.625 11.375 1.79 11.375 4V8C11.375 10.21 10.21 11.375 8 11.375ZM4 1.375C2.21 1.375 1.375 2.21 1.375 4V10.5C1.375 10.57 1.43 10.625 1.5 10.625H8C9.79 10.625 10.625 9.79 10.625 8V4C10.625 2.21 9.79 1.375 8 1.375H4Z" fill="#344854"/>
                            <path d="M8.5 5.125H3.5C3.295 5.125 3.125 4.955 3.125 4.75C3.125 4.545 3.295 4.375 3.5 4.375H8.5C8.705 4.375 8.875 4.545 8.875 4.75C8.875 4.955 8.705 5.125 8.5 5.125Z" fill="#344854"/>
                            <path d="M7 7.625H3.5C3.295 7.625 3.125 7.455 3.125 7.25C3.125 7.045 3.295 6.875 3.5 6.875H7C7.205 6.875 7.375 7.045 7.375 7.25C7.375 7.455 7.205 7.625 7 7.625Z" fill="#344854"/>
                        </svg>

                        {t('reviews.comment')}
                    </span>
                    <p className="bg-grey-100 rounded-[8px] px-[12px] py-[4px] mt-[4px] text-grey-900 font-[500]">{review?.review?.comment}</p>
                </div>

                

                

            </div>

            <div className="border-t-[1px] border-grey-200 mt-[4px] absolute bottom-[12px] left-[12px] right-[12px]">
                {Object?.keys(review?.review)?.map((r,i)=>{
                    if (!review?.review[r] || !REVIEWS_TAGS[r]?.ar) return '';
                    return (<div key={'review-'+i} className="bg-grey-100 rounded-[20px] px-[8px] py-[4px] me-[8px] inline-block align-middle mt-[12px] text-darkBlue font-[500] text-[12px]">{REVIEWS_TAGS[r]?.[i18n.language === 'ar' ? 'ar' : 'en'] || REVIEWS_TAGS[r]?.ar}</div>)
                })}
                
            </div>




        </div>


        {addWorkerToRequset && <WorkerModalContainer heading={t('reviews.chooseWorker')} handleCloseModal={handleCloseModal}>
          <div className="">
            <div className="w-full">
                <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                    <div className="w-[50%]">
                        <div className="inline-block me-[4px]">
                            {FIELD_ICON(review?.field,16,16,'fill-blue')}
                        </div>
                        <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                            {fields?.find(f=>f?.field?.code === review?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === review?.field)?.field?.name?.ar}
                        </div>
                    </div>
                    <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                        {t('reviews.since')} {moment(review?.createdAt).format('DD/MM/YYYY')}
                    </div>
                </div>
                <div className="pt-[12px]">
                    <div className="text-center mb-[10px] h-[24px]">
                        {newRequest && <div className="inline-block bg-[#0CB450]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#0CB450] text-[12px] font-[500]">{t('reviews.new')}</div>}
                        {review?.customer?.activeSubscription && review?.customer?.activeSubscription?.status === 'active' && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('reviews.faniHappy')}</div>}
                        {review?.business?._id && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('reviews.faniAamal')}</div>}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            #
                             {t('reviews.requestNumberLabel')}
                        </span>
                        {review?.reviewPrettyId}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('reviews.customerName')}
                        </span>
                        {review?.customer?.name} - <span dir="ltr">{`[ ${review?.customer?.username} ]`}</span>
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/review-payment-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('reviews.paymentMethod')}
                        </span>
                        {PAYMENT_METHOD[review?.paymentMethod]?.[i18n.language === 'ar' ? 'ar' : 'en'] || PAYMENT_METHOD[review?.paymentMethod]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-city-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('reviews.cityLabel')}
                        </span>
                        {CITIES[review?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[review?.city]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('reviews.districtLabel')}
                        </span>
                        {review?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || review?.district?.ar || '-'}
                    </div>

                    <div className="flex flex-nowrap bg-white px-[16px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{t('reviews.service')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">{t('reviews.quantity')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{t('reviews.cost')}</div>
                    </div>
                    {review?.maintenanceListHistory?.length > 0 ? review?.maintenanceListHistory?.map((item,index)=> {
                        return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px] mt-[10px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{getServiceName(item?.deviceCode,item?.maintenanceCode)}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                    </div>)})
                    : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('reviews.noServicesAvailable')} </div>}

                </div>
            </div>
            <div className="">
                <div className="mt-[20px] pt-[10px] border-t-[1px] border-grey-200">
                    <MultiSelect isMulti={false} label={t('reviews.chooseWorker')} placeholder={t('reviews.searchWorker')} options={workersOptions} value={selectedWorker} onChange={(option)=>{setSelectedWorker(option.value )}} />
                </div>
            </div>
            <div className="w-full pt-[15px] text-end">
                <NormalButton label={t('reviews.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                <NormalButton label={t('reviews.assignWorker')}  isDisabled={isButtonDisabled} onClick={()=>handleAddWorkerAction(review?._id,selectedWorker, review?.business)} />
            </div>
          </div>
        </WorkerModalContainer>}

        </>
    )
}

export default ReviewCard;
